import React from 'react';
import VisibilitySensor from "react-visibility-sensor";
import cell41 from "../../../assets/images/home/cell-4/1.svg";
import imgJoseLuisDorronsoro from "../../../assets/images/home/jose-luis-dorronsoro.jpg";
import imgFedericoDorronsoro from "../../../assets/images/home/federico-dorronsoro.jpg";

let thisComponent;

class About extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  isVisible: null
	  };
	};

	componentWillMount() {
		thisComponent = this;
	}

	onVisibilityChange(isVisible) {
		if (isVisible) { // Solamente cambia visibilidad a TRUE
			thisComponent.setState({isVisible})
		}
	}

	render() {
		const { id } = this.props;

		return (
			<VisibilitySensor
				onChange={this.onVisibilityChange}
			>
				<section id={id} className={`about ${this.state.isVisible ? "-visible" : "-hidden"}`}>
					<div className="about__wrapper container">
						<div className="row">
							<div className="about__info col">
								<h2 className="subtitle">Nosotros</h2>
								<h3 className="title">Somos una familia de bioquímicos dedicados y apasionados.</h3>
								<p className="text">Dos generaciones de una familia dedicada a la salud de la comunidad de Las Flores.</p>
							</div>
							<div className="col people">
								<div className="person">
									<img src={imgFedericoDorronsoro} alt="Dr. Federico Dorronsoro" className="person__image"/>
									<div className="person__description">
										<p className="text">Dr. Federico Dorronsoro</p>
										<p className="text"><strong>Director</strong></p>
									</div>
								</div>
								<div className="person">
									<img src={imgJoseLuisDorronsoro} alt="Dr. Jose Luis Dorronsoro" className="person__image"/>
									<div className="person__description">
										<p className="text">Dr. José Luis Dorronsoro</p>
										<p className="text"><strong>Director Fundador - 1978</strong></p>
									</div>
								</div>
							</div>
						</div>
						<img src={cell41} alt="" className="about__cell-image"/>
					</div>
				</section>
			</VisibilitySensor>
		)
	}
};

export default About;